import { styled } from 'styled-components';

import { colors, cssBreakpoints, spacing, transition } from 'theme/theme';

export const CheckboxPillsUl = styled.ul<{
  $maxDesktopWidth: number | undefined;
}>`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing[40]};

  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    flex-direction: column;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: ${(props) =>
      props.$maxDesktopWidth && `${props.$maxDesktopWidth}px`};
  }

  li {
    list-style: none;
  }

  label {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 36px;
    cursor: pointer;
    transition: ${transition};
    transition-property: background-color, color, width;
    user-select: none;
    width: 100%;

    > span {
      gap: 0;
      width: 100%;
    }

    > span > :last-child {
      flex: 0;
      justify-content: flex-end;
      opacity: 0;
      overflow: hidden;
      transition: ${transition};
      transition-property: opacity, flex;
      width: 0;
    }

    &:has(input:checked) {
      width: calc(100% + 8px);

      > span,
      > span:hover {
        background: ${colors.selectionBlue};
        color: ${colors.brandBlue};
        gap: inherit;
      }

      > span > :last-child {
        flex: 1;
        opacity: 1;
        width: 100%;
      }
    }
  }
`;
